module.exports = __webpack_public_path__ + "static/img/sq.25df02e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sq.png
// module id = WyiD
// module chunks = 1